import { useApp, useTriggerAction } from '@libs/hooks';
import { TWidget } from '@libs/types';
import { SplitText } from '@libs/utils';
import React, { useState } from 'react';
import { TCardBalanceData, TCardBalanceDataMessages } from '../../../../types/data';
import { ButtonRow } from '../../../Buttons/ButtonRow';
import { PopupComponent } from '../../../UI/Popup/PopupComponent';
import { CardBalanceActionName } from '../utils/utils';

type TCancelAndReissueCard = {
    widget: TWidget<TCardBalanceData>;
    messages: TCardBalanceDataMessages;
};
export const CancelAndReissueCard = ({ widget, messages }: TCancelAndReissueCard) => {
    const [disclaimer, toggleDisclaimer] = useState(false);

    const { setPopup } = useApp();
    const { triggerActionsByType } = useTriggerAction(widget);

    return (
        <PopupComponent
            header={disclaimer ? <SplitText text={messages.reissueDescription} as={'p'} /> : null}
            externalContent={[
                <ButtonRow
                    key="cancelAndReissueCard"
                    isWidget={false}
                    isHide={false}
                    disabled={false}
                    as={'button'}
                    handleClick={() => {
                        if (disclaimer) {
                            setPopup(null);
                            triggerActionsByType(CardBalanceActionName.getNewCard, { isShowLoader: true }).catch((e) => console.log(e));
                        } else {
                            toggleDisclaimer(true);
                        }
                    }}
                    label={disclaimer ? messages.getNewCardBtn : messages.cancelReissueCardBtn}
                    iconName={disclaimer ? 'ic_check' : 'ic_scissors'}
                />,
            ]}
        />
    );
};
